import styled from "styled-components";

import { theme } from "../../themes/themes";
export const SubPolicyTableContainer = styled.div`
  thead {
    th {
      font-weight: 700;
    }
    background-color: ${({ theme }) => theme.neutral.gray[700]};
  }
  tr {
    background-color: ${({ theme }) => theme.neutral.gray[400]};
  }
  th,
  td {
    padding-top: 0;
    padding-bottom: 0;
  }
  .empty-msg {
    height: 50px;
    display: flex;
    justify-content: center;
    border: 1px solid ${({ theme }) => theme.neutral.gray[800]};
    align-items: center;
  }
  .selected-row {
    background-color: #f7eaf7 !important;
  }
  .MuiFormControlLabel-root {
    margin: 0;
  }
`;
